<!-- 顶部导航 -->
<template>
  <div class="headerBox">
    <div class="container-wc menubar" @touchmove.prevent>
      <div class="logo">
        <img @click.stop="skipPage(0)" src="../assets/image/logo.png">
      </div>
      <ul style="margin:0;padding:0;" v-show="!isSearch">
        <li :class="active == '-1' && 'nav-active'">
          <a @click.stop="skipPage(0)">
            <span class="title">首页</span>
            <img src="../assets/img/more.png" class="more">
          </a>
        </li>
        <li :class="active == item.scode && 'nav-active'" v-for="(item, index) of tree" :key="index">
          <a @click.stop="skipPage(item)">
            <span class="title">{{ item.name }}</span>
            <img src="../assets/img/more.png" class="more">
          </a>
          <div class="subnav" v-if="item.subs">
            <span v-for="(value, key) of item.subs" :key="key" @click.stop="skipPage(value)">{{ value.name
            }}</span>
          </div>
        </li>
      </ul>

      <div class="search">
        <div class="box" v-show="isSearch">
          <input type="text" v-model="keyword" @keyup.enter="tosearch" placeholder="请输入关键词">
          <button @click="tosearch">搜索</button>
        </div>
        <img src="../assets/image/search.png" class="icon0" v-show="!isSearch" @click="isSearch = true">
        <img src="../assets/image/close.png" class="icon0" v-show="isSearch" @click="isSearch = false">
      </div>
      <div id="toggleBar" class="bar"><img src="../assets/img/action.png" alt="" class="nav-logo">
      </div>
    </div>
    <!-- <div class="subnav">
      <div class="s" v-if="active == -1">
        <span :class="active == '-1' && 'active'" @click.stop="skipPage(0)">首页</span>
        <span :class="active == item.scode && 'active'" v-for="(item, index) of tree" :key="index"
          @click.stop="skipPage(item)">{{
              item.name
          }}</span>
      </div>

      <div class="s">
        <span :class="subActive == index && 'active'" v-for="(item, index) of subTree" :key="index"
          @click.stop="skipPage(item)">{{ item.name }}</span>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  inject: ["skipPage"],
  data() {
    return {
      xd_flag: false,
      isSearch: false,
      keyword: "",
    };
  },

  computed: {
    //所有菜单
    tree() {
      return this.$store.state.user.tree;
    },
    //主菜单选中
    active() {
      return this.$store.state.user.active;
    },
    //侧边栏选中
    subActive() {
      return this.$store.state.user.subActive;
    },

    //侧边栏菜单
    subTree() {
      return this.$store.state.user.subTree;
    },

  },

  mounted() {
    let toggleBar = document.getElementById("toggleBar");
    let MenubarUl = document.querySelector(".menubar ul");
    let LeftSildeMenubar = document.querySelector(".menubar ul");

    //显示侧滑导航栏
    toggleBar.onclick = function () {
      LeftSildeMenubar.classList.toggle("active");
      document.body.style.overflow = "hidden";
    };

    //隐藏策划导航栏
    MenubarUl.onclick = function () {
      LeftSildeMenubar.classList.remove("active");
      document.body.style.overflow = "scroll";
    };
  },
  methods: {

    //搜索
    tosearch() {
      let vm = this;
      this.$router.push({
        path: "/search",
        query: {
          keyword: vm.keyword,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.subnav {
  display: none;
}

.nav-active .title {
  color: #b50104 !important;
  border-bottom: 2px solid #b50104 !important;
  box-sizing: border-box !important;
  transition: none !important;
}

.nav-logo {
  display: none;
  width: 30px;
  margin-top: 15px;
  vertical-align: middle;
  margin-left: 15px;
}

.xd-active {
  opacity: 1 !important;
  box-shadow: 0 0 6px #0d0d0dab;
}

.xys-info {
  display: none;
}

.content {
  width: 100%;
  height: 100%;
  text-align: center;
}

.search {
  display: flex;

  .box {
    border: 1px solid #ddd;
    height: 40px;
    margin: 25px 0;
    display: flex;
    align-items: center;
    width: 340px;

    input {
      height: 38px;
      border: 0;
      outline: none;
      width: 280px;
      padding-left: 12px;
      font-size: 14px;
    }

    button {
      width: 58px;
      height: 38px;
      border: 1px solid #ddd;
      outline: none;
      background-color: #b50104;
      color: #fff;
    }
  }

  .icon0 {
    margin: 35px 10px 35px 25px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.headerBox {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background-color: rgba(255, 255, 255, .6);
}

.menubar {
  height: 90px;
  display: flex;
  flex-direction: row;
  user-select: none;
  z-index: 100;
  background-color: transparent;
  width: 1300px;
  .logo {
    flex: 1;
    text-align: left;
    padding: 10px 0;
    cursor: pointer;
    
    img {
      height: 70px;
    }
  }

  .logotitle {
    width: 100%;
    line-height: 60px;
    font-size: 24px;
    color: #fff;
  }

  .user {
    width: 20%;
    min-width: 80px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-right: 30px;
    align-items: center;
    cursor: pointer;

    .userimg {
      width: 60px;
      height: 60px;

      img {
        width: 36px;
        height: 36px;
        margin-top: 12px;
        margin-right: 0px;
        border-radius: 50%;
      }
    }

    .username {
      font-size: 14px;
      color: #eee;
      height: 60px;
      line-height: 60px;
    }
  }

  .subnav {
    height: 0;
  }

  ul {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: left;
    text-align: center;

    li {
      min-width: 50px;
      list-style: none;
      margin-left: 18px;
      padding: 0 15px;
      transition: all 0.2s ease;
      cursor: pointer;
      position: relative;

      &:hover {
        .subnav {
          height: auto;
          padding: 8px 0;
        }
      }

      .subnav {
        position: absolute;
        overflow: hidden;
        height: 0;
        left: 0;
        top: 90px;
        width: 100%;
        // padding-left: 70px;
        
        transition: all 0.3s;
        background-color: rgba(0, 0, 0, 0.25);
        display: block;
        z-index: 9999;
        

        span {
          color: #fff;
          transition: all 0.3s;
          // padding: 0 30px;
          font-size: 16px;
          line-height: 40px;
          text-align: center;
          display: block;
          // padding-left: 15px;
          &:hover {
            color: #b50104;
          }
        }
      }

      a {
        position: relative;
        display: block;
        width: 100%;

        text-decoration: none;

        .more {
          display: none;
        }

        .title {
          position: relative;
          display: block;
          line-height: 90px;
          height: 90px;
          text-align: center;
          font-size: 18px;
          color: #000;
        }
      }

      a:hover span {
        transition: all 0.3s ease;
        color: #b50104;
      }
    }
  }
}

.list {
  margin-left: 5%;
  margin-right: 5%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: center;
  justify-content: space-around;
  align-items: center;

  .item {
    flex-basis: 23%;
    margin-top: 22px;
    height: 260px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    transition: 0.314s;
    cursor: pointer;

    .desc {
      width: 90%;
      margin: 16px;
      flex-basis: 80%;
      background-color: #f5f5f5;
    }

    .title {
      width: 90%;
      margin: auto 16px;
      margin-bottom: 16px;
      flex-basis: 20%;
      background-color: #f5f5f5;
    }
  }

  .item:hover {
    transform: scale(1.02);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  }
}

.footer {
  position: relative;
  bottom: 0;
  height: 172px;
  color: #a5a5a5;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue